import type { ReactNode } from 'react'

import { CommunitySubscriptionCard } from '@/src/features/community/ui/components/CommunitySubscriptionCard'
import type { TFeedItemApi } from '@/src/features/prayer-space/api/feedApi.types'
import { FEED_ITEM_TYPE } from '@/src/features/prayer-space/models/prayerSpace.constants'

import { FeedPublicationItem } from './FeedPublicationItem'

type TPrayerSpaceItemProps = { item: TFeedItemApi; index: number }

export const PrayerSpaceItem = ({ item, index }: TPrayerSpaceItemProps): ReactNode => {
  // Welcome type is never reached here
  if (item.type === FEED_ITEM_TYPE.WELCOME) return null

  if (item.type === FEED_ITEM_TYPE.PUBLICATION)
    return <FeedPublicationItem publication={item.publication} index={index} />

  return <CommunitySubscriptionCard communityFeedItem={item} />
}
